/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";

import { putRequest } from "utils/request";

import { postRequest } from "utils/request";

import { i18n } from '../../../../translate/i18n'

export default function NewUserType({
  handleNewUserType,
  companyId,
  selectedUserType,
  handleGoBack,
  match
}) {
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    setDescription(selectedUserType.description);

    setLoading(false);
  }, []);

  const handleSendUserType = () => {
    setLoading(true);

    if (selectedUserType.id) {
      putRequest(`/companiescustomerstypes/${selectedUserType.id}`, {
        description: description,
        CompanyId: match.params.id
      })
      .then(function (response) {
          setLoading(false);
          if(response.success) {
            handleNewUserType();
          }  
        }
      )
  } else {
      postRequest(`/companiescustomerstypes`, {
        description: description,
        CompanyId: companyId,
      })
      .then(function (response) {
        setLoading(false);
        if(response.success) {
          handleNewUserType();
        }
      }
    )
    }
  };

  return (
    <>
      {!loading ? (
        <form
          style={{height: '60vh' , overflow: 'hidden'}}
          className="form-edit"
          onSubmit={(e) => {
            e.preventDefault();
            handleSendUserType();
          }}
        >
          <div style={{paddingLeft: 0}} className="col-lg-12">
            <div className="form-row mt-2">
              <div className="form-group col-md-3">
                <label> {i18n.t('description')} *</label>
                <input
                  type="text"
                  className="form-control"
                  maxLength={100}
                  value={description}
                  required
                  onChange={(value) => setDescription(value.target.value)}
                />
              </div>
            </div>
            <div
              className="button-list mt-3 pull-right"
              style={{ position: "absolute", bottom: 0, right: 0 }}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i i className="mdi mdi-backup-restore"></i>
                {i18n.t('getBack')}
              </button>
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
